import { render, staticRenderFns } from "./add-menu-group.vue?vue&type=template&id=5e2bf287&scoped=true"
import script from "./add-menu-group.vue?vue&type=script&lang=js"
export * from "./add-menu-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bf287",
  null
  
)

export default component.exports